import { clsx } from 'clsx';
import * as React from 'react';
import IconFontAwesome from "../../js/components/iconFontAwesome.tsx";
import type { MenuItemData } from "../../js/data/menuItemData.ts";
import { MenuItemType } from "../../js/generated/enums/menuItemType.ts";

type MenuItemTitleProps = React.ComponentPropsWithoutRef<"a"> & {
	item: MenuItemData,
	subMenuItems: MenuItemData[],
	depth?: number,
	pathname: string,
}

function getUrlForMenuItem(item: MenuItemData) {
	let toReturn = '';

	switch (item.typeId) {
		case MenuItemType.Url:
			toReturn = item?.url;
			break;
		case MenuItemType.Page:
			toReturn = item?.page?.absoluteUrl;
			break;
	}

	return toReturn;
}

function MenuItemTitle({ item, subMenuItems, pathname, depth = 0, className }: MenuItemTitleProps) {
	const url = getUrlForMenuItem(item);

	const name = <>
		{item.title}
		{/*{subMenuItems.length > 0 && <>*/}
		{/*	&nbsp;*/}
		{/*	<IconFontAwesome className={clsx(depth === 0 ? "icon-chevron-down" : 'icon-chevron-right', "text-inherit")}/>*/}
		{/*</>}*/}
	</>

	return (<>
		{item.typeId === MenuItemType.Label ?
			<span className={className}>{name}</span> :
			<a href={url} className={clsx(pathname === url && "current", className)}>{name}</a>
		}
	</>);
}

export default MenuItemTitle;
